// 错误处理方案： 错误类型
import store from '@/store';
import { handleLogout } from '@/store/actions';
import { AxiosResponse, RequestConfig } from '@@/plugin-request/request';
import { notification } from 'antd';

// 错误展示类型
enum ErrorShowType {
  SILENT = 0,
  WARN_MESSAGE = 1,
  ERROR_MESSAGE = 2,
  NOTIFICATION = 3,
  REDIRECT = 9,
}

// 统一响应格式
interface ResponseStructure {
  code: number;
  data: any;
  message?: string;
  errorCode?: number;
  errorMessage?: string;
  showType?: ErrorShowType;
}

// interface ResponseData {
//   code: number;
//   message: string;
//   data: any;
//   url: string;
//   operate: string;
// }

// 错误处理配置
const errorConfig = {
  errorThrower: (res: ResponseStructure) => {
    const { code, errorMessage, errorCode, showType } = res;
    if (![10000, 20000].includes(code)) {
      const error: any = new Error(errorMessage);
      error.name = 'BizError';
      error.info = { errorCode, errorMessage, showType };
      throw error;
    }
  },
  errorHandler: (error: any, opts: any) => {
    if (opts?.skipErrorHandler) throw error;

    // 业务错误处理
    if (error.name === 'BizError') {
      const { errorMessage, errorCode, showType } = error.info;
      if (errorCode === 43002) {
        store.dispatch(handleLogout());
        return;
      }
      handleErrorNotification(errorMessage, showType);
      return;
    }

    // 网络错误处理
    if (error.response) {
      handleErrorNotification(`请求失败: ${error.response.status}`);
    } else if (error.request) {
      handleErrorNotification('服务器无响应');
    } else {
      handleErrorNotification(error.message || '请求发送失败');
    }
  },
};

// 错误通知处理
const handleErrorNotification = (message: string, showType?: ErrorShowType) => {
  const notificationConfig = {
    message: '网络提示',
    description: message,
    showProgress: true,
    placement: 'top' as const,
    pauseOnHover: true,
  };

  switch (showType) {
    case ErrorShowType.SILENT:
      break;
    case ErrorShowType.WARN_MESSAGE:
      notification.warning(notificationConfig);
      break;
    case ErrorShowType.ERROR_MESSAGE:
    case ErrorShowType.NOTIFICATION:
      notification.error(notificationConfig);
      break;
    case ErrorShowType.REDIRECT:
      // TODO: 实现重定向逻辑
      break;
    default:
      notification.error(notificationConfig);
  }
};

// 运行时配置
export const RequestSetting: RequestConfig = {
  // 统一的请求设定
  timeout: 100000,
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
  errorConfig,

  // 请求拦截器
  requestInterceptors: [
    (config: any) => {
      const { token, user_info } = store.getState().user;
      config.headers.common.token = token;
      config.headers.authorization = `${user_info.token_type} ${token}`;
      return config;
    },
  ],

  // 响应拦截器
  responseInterceptors: [
    (response: AxiosResponse) => {
      const { data } = response;

      // 处理特殊状态码
      if (data.code === 43002) {
        store.dispatch(handleLogout());
        return data;
      }

      if (data.code == 20000) {
        return response;
      }
      // 处理业务错误
      if (data.code !== 10000) {
        throw data;
      }

      return data;
    },
  ],
};
